// Database connection utility using Prisma with MySQL
import { PrismaClient } from '@prisma/client';

// Prevent multiple instances of Prisma Client in development
const globalForPrisma = globalThis as unknown as {
  prisma: PrismaClient | undefined;
};

export const prisma = globalForPrisma.prisma ?? new PrismaClient();

if (process.env.NODE_ENV !== 'production') globalForPrisma.prisma = prisma;

// Export User type from Prisma
export type User = {
  id: string;
  fullName: string;
  email: string;
  phone: string;
  passwordHash: string;
  createdAt: Date;
  updatedAt: Date;
};

// Database operations wrapper
export const db = {
  users: {
    create: async (data: Omit<User, 'id' | 'createdAt' | 'updatedAt'>): Promise<User> => {
      return prisma.user.create({
        data: {
          fullName: data.fullName,
          email: data.email,
          phone: data.phone,
          passwordHash: data.passwordHash,
        },
      });
    },
    
    findByEmail: async (email: string): Promise<User | null> => {
      return prisma.user.findUnique({
        where: { email: email.toLowerCase() },
      });
    },
    
    findById: async (id: string): Promise<User | null> => {
      return prisma.user.findUnique({
        where: { id },
      });
    },
  },
};
